import React from 'react';

export default function JournalCard({
  image = 'linear-gradient(165deg, #c4a87c, #5D4A3B)',
  category,
  title,
  excerpt,
  date,
  readTime,
  href = '#',
  className = '',
}) {
  return (
    <a 
      href={href}
      className={`group block rounded-card-l overflow-hidden bg-ivory transition-all duration-500 hover:-translate-y-2 hover:shadow-card ${className}`}
    >
      <div className="aspect-[16/10] overflow-hidden">
        <div 
          className="w-full h-full transition-transform duration-700 group-hover:scale-105"
          style={{ background: image }}
        />
      </div>
      
      <div className="p-7">
        {category && (
          <div className="text-eyebrow uppercase text-gold tracking-wider mb-3 font-semibold">
            {category}
          </div>
        )}
        
        <h3 className="font-serif text-[22px] text-warm-black mb-3 font-medium leading-[1.25] tracking-tight">
          {title}
        </h3>
        
        {excerpt && (
          <p className="text-[14px] text-muted leading-[1.6] mb-5">
            {excerpt}
          </p>
        )}
        
        {(date || readTime) && (
          <div className="flex items-center gap-3 text-tiny text-muted/80 tracking-wide">
            {date && <span>{date}</span>}
            {date && readTime && <span>·</span>}
            {readTime && <span>{readTime}</span>}
          </div>
        )}
      </div>
    </a>
  );
}